<div class="info-box">
  @if (title) {
    <h3 class="info-box__title">
      <span class="skeleton">{{ title | translate }}</span>
    </h3>
  } @else {
    <ng-content select=".info-box__title"></ng-content>
  }
  <ul class="info-list">
    <ng-content></ng-content>
  </ul>
</div>
